import { render, staticRenderFns } from "./valeGasolinaIndex.vue?vue&type=template&id=4b5e924a&scoped=true&"
import script from "./valeGasolinaIndex.vue?vue&type=script&lang=ts&"
export * from "./valeGasolinaIndex.vue?vue&type=script&lang=ts&"
import style0 from "./valeGasolinaIndex.vue?vue&type=style&index=0&id=4b5e924a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e924a",
  null
  
)

export default component.exports